import React, { useState } from 'react';
import MyInvoisLayout from './components/myinvois_layout';
import ContainerComponent from '../../helpers/components/container.component';
import { useLocation } from 'react-router-dom';

const MyInvoisIndex = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [filter, setFilter] = useState({
        page : queryParams.get("page"),
        // parks : queryParams.get("parks")?.split(',')?.map(Number)?.filter(x => x != 0),
        search : queryParams.get("search"),
        expand_key : queryParams.get("expand_key"),
    })

    return (
        <>
            <ContainerComponent span={22} top={20}>
                <MyInvoisLayout default_filter={filter} />
            </ContainerComponent>
        </>
    );
}

export default MyInvoisIndex;